import React from 'react';
import PropTypes from 'prop-types';

const CCustosForm = (props) => {
    return (
        <div className="row">
            <div className="form-group col-5 col-md-6">
                <input type="text" placeholder="Centro de Custo..." className="form-control"
                    value={props.ccusto.nome} autoFocus
                    onChange={evt => props.handleChange(evt)} />
            </div>
            <div className="form-group col-3 col-md-4">
                <input type="text" placeholder="Código..." className="form-control"
                    value={props.ccusto.codigo_icone}
                    onChange={props.handleChangeIcone} />
            </div>
            <div className="form-group col-2 col-md-1">
                <a href="http://fontawesome.io/icons/" target="_blank" rel="noopener noreferrer">
                    <h3><span className="badge badge-dark"><i className={`fas fa-${props.ccusto.codigo_icone}`} /></span></h3>
                </a>
            </div>
            <div className="form-group col-2 col-md-1">
                <button type="button" className="btn btn-primary btn-block" onClick={props.handleSave} >
                    <i className="far fa-save" />
                </button>
            </div>
        </div>
    );
};

CCustosForm.propTypes = {
    handleSave: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    handleChangeIcone: PropTypes.func.isRequired,
    ccusto: PropTypes.object.isRequired,
};

export default CCustosForm;


// WEBPACK FOOTER //
// ./src/components/ccustos/CCustosForm.js